import { Link } from 'react-router-dom';
import './Profile.css';

export type ProfileContactSummaryProps = {
  email: string;
  phone?: string | null;
  /** When true, scroll target is on the same page; otherwise link to /profil#profile-contact-edit */
  onSamePage?: boolean;
};

export default function ProfileContactSummary({
  email,
  phone,
  onSamePage = true,
}: ProfileContactSummaryProps) {
  const phoneLabel = phone?.trim() ? phone : 'Henüz eklenmedi';

  const handleScrollToEdit = () => {
    document.getElementById('profile-contact-edit')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const updateButton = onSamePage ? (
    <button
      type="button"
      className="btn btn-primary sb-profile-contact-update-btn"
      onClick={handleScrollToEdit}
    >
      <i className="fas fa-address-card me-2" aria-hidden="true" />
      İletişim Bilgilerini Güncelle
    </button>
  ) : (
    <Link to="/profil#profile-contact-edit" className="btn btn-primary sb-profile-contact-update-btn">
      <i className="fas fa-address-card me-2" aria-hidden="true" />
      İletişim Bilgilerini Güncelle
    </Link>
  );

  return (
    <div className="card mb-4">
      <div className="card-body">
        <h5 className="card-title mb-3">İletişim Bilgileri</h5>
        <dl className="row mb-0 sb-profile-contact-summary">
          <dt className="col-sm-4 text-muted">E-posta</dt>
          <dd className="col-sm-8 mb-2 text-break">{email || '—'}</dd>
          <dt className="col-sm-4 text-muted">Telefon</dt>
          <dd className="col-sm-8 mb-0 text-break">{phoneLabel}</dd>
        </dl>
        <div className="sb-form-actions mt-3 pt-1">{updateButton}</div>
      </div>
    </div>
  );
}
